import { callApi } from "@/api/api-core";

export const payAnonymousDeveloper = function(orderId, ownerHandlesFailure) {
    const requestData = {
        orderId: orderId
    };

    return callApi(
        "POST",
        "v2/payment/developer/pay/anonymous",
        requestData,
        ownerHandlesFailure
    );
};

export const payAnonymousFree = function(orderId, ownerHandlesFailure) {
    const requestData = {
        orderId: orderId
    };

    return callApi(
        "POST",
        "v1/payment/free/pay/accountlesscustomer",
        requestData,
        ownerHandlesFailure
    );
};

export const exchangeDownloadTokenDeveloper = function(
    orderId,
    ownerHandlesFailure
) {
    const requestData = {
        orderId: orderId
    };

    return callApi(
        "POST",
        "v2/payment/developer/exchange/downloadtoken",
        requestData,
        ownerHandlesFailure
    );
};

export const exchangeDownloadTokenFree = function(
    orderId,
    ownerHandlesFailure
) {
    const requestData = {
        orderId: orderId
    };

    return callApi(
        "POST",
        "v1/payment/free/exchange/downloadtoken",
        requestData,
        ownerHandlesFailure
    );
};

export const initNetaxept = function(
    orderId,
    redirectUrl,
    language,
    ownerHandlesFailure
) {
    const requestData = {
        orderId,
        redirectUrl,
        language
    };

    return callApi(
        "POST",
        "v1/payment/netaxept/payment/init/webshop",
        requestData,
        ownerHandlesFailure
    );
};

export const initApplePay = function(
    orderId,
    token,
    ownerHandlesFailure
) {
    const requestData = {
        orderId,
        paymentData: JSON.stringify(token),
    };

    return callApi(
        "POST",
        "v1/payment/netaxept/payment/init/applepay/webshop",
        requestData,
        ownerHandlesFailure
    );
};

export const finalizeNetaxept = function(
    orderId,
    transactionId,
    ownerHandlesFailure
) {
    const requestData = {
        orderId,
        transactionId
    };

    return callApi(
        "POST",
        "v2/payment/netaxept/payment/finalize/webshop",
        requestData,
        ownerHandlesFailure
    );
};
